export default __webpack_public_path__ + "static/media/flipp.6ffc23a6.mp3";